// ============================================================
//  KIDS PARTY BOOKING BLOCK
//  Upload to: Shopify Admin → Themes → Edit code → Assets
// ============================================================

// Declared first, before anything else, because kpInit() runs
// synchronously as soon as it's defined further down in this file —
// these constants must already exist by then (kpLoadMemberConfig,
// called from inside kpInit, depends on them immediately).
var KP_SUPABASE_URL = 'https://snxibhbhhchjthfmjtaj.supabase.co';
var KP_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNueGliaGJoaGNoanRoZm1qdGFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwNTk2ODAsImV4cCI6MjA5MjYzNTY4MH0.K-89Mx4SxU6N1hMmtK6Q79rWAtk6VTN9b5wemQxcZVA';
var KP_COLLECTION_ID = '301329743962';

// ============================================================
//  PROJECT OPTIONS
// ============================================================
var KP_PROJECT_OPTIONS = [
  { value: 'oven-bake',  label: 'Oven-Bake Clay' },
  { value: 'clay',       label: 'Clay (+$40)' },
  { value: 'painting',   label: 'Painting (+$40)' },
  { value: 'besties',    label: 'Besties (+$40)' },
  { value: 'undecided',  label: 'Undecided' }
];
var KP_PROJECT_LABELS = { clay: 'Clay', painting: 'Painting', 'oven-bake': 'Oven-Bake Clay', besties: 'Besties', undecided: 'Undecided' };
var KP_UPGRADE_PROJECTS = ['clay', 'painting', 'besties'];
var KP_UPGRADE_VARIANT_ID = 43176665677914;
// $40 custom write-in project fee (confirmed variant ID, not product ID).
var KP_CUSTOM_VARIANT_ID = 40199990739034;
// Categories that show a second "which specific project" dropdown.
// Options for each are supplied at runtime via window.__KP_SPECIFIC_PROJECTS__
// (populated from the page's "Party Project Options" metafield in the liquid file).
var KP_CATEGORIES_WITH_SUBPROJECT = ['clay', 'painting', 'oven-bake'];

// ============================================================
//  STUDIO MAP (same naming convention across all booking widgets)
// ============================================================
var KP_STUDIOS = {
  "British Columbia": [
    { name: "Richmond \u2013 Garden City",         variantName: "BC / RICHMOND - GARDEN CITY" },
    { name: "Richmond \u2013 Steveston",           variantName: "BC / RICHMOND - STEVESTON" },
    { name: "Surrey \u2013 South",                variantName: "BC / SURREY - SOUTH" },
    { name: "Vancouver \u2013 Kitsilano",          variantName: "BC / VANCOUVER - KITSILANO" },
    { name: "Vancouver \u2013 Main Street",        variantName: "BC / VANCOUVER - MAIN STREET" },
    { name: "Vancouver \u2013 UBC",               variantName: "BC / VANCOUVER - UBC" },
    { name: "Victoria \u2013 Cook Street Village", variantName: "BC / VICTORIA - COOK STREET VILLAGE" },
    { name: "Victoria \u2013 Esquimalt",           variantName: "BC / VICTORIA - ESQUIMALT" },
    { name: "Victoria \u2013 Oak Bay",             variantName: "BC / VICTORIA - OAK BAY" },
    { name: "Victoria \u2013 Uptown",              variantName: "BC / VICTORIA - UPTOWN" }
  ],
  "Alberta": [
    { name: "Calgary \u2013 Inglewood", variantName: "AB / CALGARY - INGLEWOOD" },
    { name: "St. Albert",              variantName: "AB / ST ALBERT" }
  ],
  "Ontario": [
    { name: "Burlington \u2013 South",            variantName: "ON / BURLINGTON - SOUTH" },
    { name: "Cambridge \u2013 Galt",              variantName: "ON / CAMBRIDGE - GALT" },
    { name: "Erin",                              variantName: "ON / ERIN" },
    { name: "Hamilton \u2013 Ottawa Street",      variantName: "ON / HAMILTON - OTTAWA STREET" },
    { name: "Hamilton \u2013 Waterdown",          variantName: "ON / HAMILTON - WATERDOWN" },
    { name: "Hamilton \u2013 West Harbour",       variantName: "ON / HAMILTON - WEST HARBOUR" },
    { name: "Kingston \u2013 Arlington Park",     variantName: "ON / KINGSTON - ARLINGTON PARK" },
    { name: "London \u2013 Byron",                variantName: "ON / LONDON - BYRON" },
    { name: "London \u2013 Wortley Village",      variantName: "ON / LONDON - WORTLEY VILLAGE" },
    { name: "Mississauga \u2013 Port Credit",     variantName: "ON / MISSISSAUGA - PORT CREDIT" },
    { name: "Oakville \u2013 North",              variantName: "ON / OAKVILLE - NORTH" },
    { name: "Oakville \u2013 West",               variantName: "ON / OAKVILLE - WEST" },
    { name: "Ottawa \u2013 The Glebe",            variantName: "ON / OTTAWA - THE GLEBE" },
    { name: "St. Catharines",                    variantName: "ON / ST CATHARINES" },
    { name: "Toronto \u2013 Avenue Road",         variantName: "ON / TORONTO - AVENUE ROAD" },
    { name: "Toronto \u2013 Baby Point",          variantName: "ON / TORONTO - BABY POINT" },
    { name: "Toronto \u2013 Leaside",             variantName: "ON / TORONTO - LEASIDE" },
    { name: "Toronto \u2013 The Beaches",         variantName: "ON / TORONTO - THE BEACHES" },
    { name: "Waterloo \u2013 Uptown",             variantName: "ON / WATERLOO - UPTOWN" }
  ]
};

// ============================================================
//  PARTY EXTRAS PRICING (verbatim from existing party-block.js)
// ============================================================
var KP_EXTRAS_VARIANTS = {
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|up to 8 people (base price)": 42477947093082,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|9 people": 42477955186778,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|10 people": 42477955219546,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|11 people": 42477955252314,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|12 people": 42477955285082,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|13 people": 42477955317850,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|14 people": 42477955350618,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|15 people": 42477955383386,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|16 people": 42477970292826,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|17 people": 42477970325594,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|18 people": 42477970358362,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|19 people": 42477970391130,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|20 people": 42477970423898,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 42477955416154,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|9 people": 42477955448922,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|10 people": 42477955481690,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|11 people": 42477955514458,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|12 people": 42477955547226,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|13 people": 42477955579994,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|14 people": 42477955612762,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|15 people": 42477955645530,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|16 people": 42477970456666,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|17 people": 42477970489434,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|18 people": 42477970522202,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|19 people": 42477970554970,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|20 people": 42477970587738,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 42477955678298,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 42477955711066,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 42477955743834,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 42477955776602,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 42477955809370,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 42477955842138,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 42477955874906,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 42477955907674,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 42477970620506,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 42477970653274,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 42477970686042,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 42477970718810,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 42477970751578,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|up to 8 people (base price)": 42477947224154,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|9 people": 42477955940442,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|10 people": 42477955973210,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|11 people": 42477956005978,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|12 people": 42477956038746,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|13 people": 42477956071514,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|14 people": 42477956104282,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|15 people": 42477956137050,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|16 people": 42477970784346,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|17 people": 42477970817114,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|18 people": 42477970849882,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|19 people": 42477970882650,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|20 people": 42477970915418,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 42477956169818,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|9 people": 42477956202586,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|10 people": 42477956235354,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|11 people": 42477956268122,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|12 people": 42477956300890,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|13 people": 42477956333658,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|14 people": 42477956366426,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|15 people": 42477956399194,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|16 people": 42477970948186,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|17 people": 42477970980954,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|18 people": 42477971013722,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|19 people": 42477971046490,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|20 people": 42477971079258,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 42477956431962,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 42477956464730,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 42477956497498,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 42477956530266,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 42477956563034,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 42477956595802,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 42477956628570,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 42477956661338,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 42477971112026,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 42477971144794,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 42477971177562,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 42477971210330,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 42477971243098
};

var KP_EXTRAS_PRICES = {
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|up to 8 people (base price)": 0,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|9 people": 1600,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|10 people": 3200,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|11 people": 4800,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|12 people": 6400,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|13 people": 8000,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|14 people": 9600,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|15 people": 11200,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|16 people": 16800,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|17 people": 18400,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|18 people": 20000,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|19 people": 21600,
  "no - 60 minutes for the art project is good!|no - just we will leave after the art portion|20 people": 23200,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 6400,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|9 people": 8800,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|10 people": 11200,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|11 people": 13600,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|12 people": 16000,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|13 people": 18400,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|14 people": 20800,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|15 people": 23200,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|16 people": 29600,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|17 people": 32000,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|18 people": 34400,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|19 people": 36800,
  "no - 60 minutes for the art project is good!|yes - add 30 minutes (enough time for cake only)|20 people": 39200,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 9600,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 12400,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 15200,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 18000,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 20800,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 23600,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 26400,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 29200,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 36000,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 38800,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 41600,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 44400,
  "no - 60 minutes for the art project is good!|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 47200,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|up to 8 people (base price)": 6400,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|9 people": 8800,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|10 people": 11200,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|11 people": 13600,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|12 people": 16000,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|13 people": 18400,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|14 people": 20800,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|15 people": 23200,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|16 people": 31600,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|17 people": 34000,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|18 people": 36400,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|19 people": 38800,
  "yes - 90 minutes of art time|no - just we will leave after the art portion|20 people": 41200,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|up to 8 people (base price)": 12800,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|9 people": 16000,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|10 people": 19200,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|11 people": 22400,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|12 people": 25600,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|13 people": 28800,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|14 people": 32000,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|15 people": 35200,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|16 people": 44400,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|17 people": 47600,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|18 people": 50800,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|19 people": 54000,
  "yes - 90 minutes of art time|yes - add 30 minutes (enough time for cake only)|20 people": 57200,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|up to 8 people (base price)": 16000,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|9 people": 19600,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|10 people": 23200,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|11 people": 26800,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|12 people": 30400,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|13 people": 34000,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|14 people": 37600,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|15 people": 41200,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|16 people": 50800,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|17 people": 54400,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|18 people": 58000,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|19 people": 61600,
  "yes - 90 minutes of art time|yes - add 45 minutes (enough time for lunch/snacks and cake)|20 people": 65200
};

var KP_BASE_EXTRAS_KEY = 'no - 60 minutes for the art project is good!|no - just we will leave after the art portion|up to 8 people (base price)';
var KP_PARENT_STAY_HANDLE = 'kids-party-parent-helper-observer';
var kpParentStayVariantId = null;
var kpParentStayPriceCents = 500;

// ============================================================
//  MEMBER PRICING — mirrors Selly's automatic checkout discount as a
//  pre-checkout estimate only. The actual charge always comes from
//  Selly at checkout regardless of what's shown here; this table is
//  the same shared app_pricing_config table used for PA/PD Days.
// ============================================================
var kpMemberTags = [];
var kpMemberDiscountConfig = { base_discount_flat_cents: 0, extras_discount_pct: 0 };
var kpIsMember = false;

function kpLoadMemberConfig(cb) {
  var url = KP_SUPABASE_URL + '/rest/v1/app_pricing_config?key=in.(member_tags,kids_party_member_discount)&select=key,value';
  fetch(url, { headers: { Authorization: 'Bearer ' + KP_ANON_KEY, apikey: KP_ANON_KEY } })
    .then(function (r) { return r.json(); })
    .then(function (rows) {
      (rows || []).forEach(function (row) {
        if (row.key === 'member_tags') kpMemberTags = row.value || [];
        if (row.key === 'kids_party_member_discount') kpMemberDiscountConfig = row.value || kpMemberDiscountConfig;
      });
      var customerTags = (window.__KP_CUSTOMER_TAGS__ || []).map(function (t) { return String(t).toLowerCase().trim(); });
      var memberTagsLower = kpMemberTags.map(function (t) { return String(t).toLowerCase().trim(); });
      kpIsMember = customerTags.some(function (t) { return memberTagsLower.indexOf(t) !== -1; });
      if (cb) cb();
    })
    .catch(function (e) {
      console.error('KP member config load error:', e);
      kpIsMember = false; // fail safe: show non-member pricing if this fails
      if (cb) cb();
    });
}

function kpLoadParentStayVariant(cb) {
  if (kpParentStayVariantId) { if (cb) cb(); return; }
  fetch('/products/' + KP_PARENT_STAY_HANDLE + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      if (product.variants && product.variants.length > 0) {
        kpParentStayVariantId = product.variants[0].id;
        kpParentStayPriceCents = product.variants[0].price;
      }
      if (cb) cb();
    })
    .catch(function (err) { console.error('KP parent stay lookup error:', err); if (cb) cb(); });
}

function kpParticipantCount(val) {
  if (!val || val.indexOf('up to 8') === 0) return 8;
  var m = val.match(/^(\d+)/);
  return m ? parseInt(m[1], 10) : 8;
}

// ============================================================
//  STATE
// ============================================================
var kpState = {
  province: null,
  studioName: null,
  studioVariantName: null,
  dateKey: null,
  dateLabel: null,
  variantId: null,
  variantPrice: null,
  timeLabel: null,
  is11am: false,
  reason: '',
  partyNotes: '',
  project: '',
  specificProject: '',
  specificProjectRaw: '',
  specificProjectLabel: '',
  customProjectText: '',
  artTime: 'no - 60 minutes for the art project is good!',
  artTimeLabel: 'No \u2013 60 minutes for the art project is good!',
  partyAfter: 'no - just we will leave after the art portion',
  partyAfterLabel: 'No \u2013 just leave after the art portion',
  participants: 'up to 8 people (base price)',
  participantsLabel: 'Up to 8 people (base price)',
  parentStay: 'no',
  calYear: null,
  calMonth: null,
  dateMap: {}
};

var KP_STEP_IDS = ['province', 'studio', 'date', 'time', 'details', 'review'];
var kpCurrentStep = 0;

// ============================================================
//  INIT
// ============================================================
function kpInit() {
  var block = document.getElementById('kp-booking-block');
  if (!block || block.dataset.kpReady) return;
  block.dataset.kpReady = '1';
  kpBuildProvinceOptions();
  kpBuildProjectOptions();
  kpBuildNotesField();
  kpBindDetailFields();
  kpLoadParentStayVariant();
  kpLoadMemberConfig(function () {
    kpUpdateDetailsSubtotal();
    kpUpdatePriceBar();
  });
  document.getElementById('kp-add-to-cart').addEventListener('click', kpAddToCart);

  if (window.__KP_PRESELECT__) {
    var pre = window.__KP_PRESELECT__;
    kpState.province = pre.province;
    kpBuildStudioOptions(pre.province);
    var studiosInProv = KP_STUDIOS[pre.province] || [];
    var match = null;
    studiosInProv.forEach(function (s) { if (s.name === pre.studioName) match = s; });
    if (match) {
      kpSetStudioLabel(match.name);
      kpState.studioName = match.name;
      kpState.studioVariantName = match.variantName;
      kpState.dateKey = null; kpState.variantId = null;
      kpGoTo(2);
      setTimeout(function () { kpFetch(match.variantName); }, 100);
    } else {
      kpGoTo(1);
    }
    window.__KP_PRESELECT__ = null;
    return;
  }

  kpGoTo(0);
}

kpInit();
document.addEventListener('DOMContentLoaded', kpInit);
window.addEventListener('load', kpInit);

// ============================================================
//  NAVIGATION
// ============================================================
function kpGoTo(stepIndex) {
  kpCurrentStep = stepIndex;
  KP_STEP_IDS.forEach(function (id, i) {
    var el = document.getElementById('kp-step-' + id);
    if (el) el.className = 'kp-step' + (i === stepIndex ? ' kp-step-active' : '');
  });
  var pct = ((stepIndex + 1) / KP_STEP_IDS.length * 100).toFixed(0) + '%';
  var bar = document.getElementById('kp-progress-bar');
  var lbl = document.getElementById('kp-progress-label');
  var back = document.getElementById('kp-back-btn');
  if (bar) bar.style.width = pct;
  if (lbl) lbl.textContent = 'Step ' + (stepIndex + 1) + ' of ' + KP_STEP_IDS.length;
  if (back) back.style.display = stepIndex > 0 ? 'inline-block' : 'none';
  var block = document.getElementById('kp-booking-block');
  if (block) setTimeout(function () { block.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
}

function kpBack() { if (kpCurrentStep > 0) kpGoTo(kpCurrentStep - 1); }
function kpNext() { kpGoTo(kpCurrentStep + 1); }

// ============================================================
//  STEP 1: Province
// ============================================================
function kpBuildProvinceOptions() {
  var container = document.getElementById('kp-province-options');
  if (!container) return;
  Object.keys(KP_STUDIOS).forEach(function (province) {
    var btn = document.createElement('button');
    btn.className = 'kp-option-btn';
    btn.textContent = province;
    btn.addEventListener('click', function () {
      kpState.province = province;
      kpBuildStudioOptions(province);
      kpNext();
    });
    container.appendChild(btn);
  });
}

// ============================================================
//  STEP 2: Studio
// ============================================================
function kpBuildStudioOptions(province) {
  var container = document.getElementById('kp-studio-options');
  if (!container) return;
  container.innerHTML = '';
  (KP_STUDIOS[province] || []).forEach(function (studio) {
    var btn = document.createElement('button');
    btn.className = 'kp-option-btn';
    btn.textContent = studio.name;
    btn.addEventListener('click', function () {
      kpState.studioName = studio.name;
      kpState.studioVariantName = studio.variantName;
      kpState.dateKey = null; kpState.variantId = null;
      kpSetStudioLabel(studio.name);
      kpGoTo(2);
      kpFetch(studio.variantName);
    });
    container.appendChild(btn);
  });
}

// ============================================================
//  FETCH
// ============================================================
// (KP_SUPABASE_URL / KP_ANON_KEY / KP_COLLECTION_ID declared at
// top of file — see note there on why the ordering matters.)

function kpFetch(variantName) {
  document.getElementById('kp-loading').style.display = 'block';
  document.getElementById('kp-calendar').innerHTML = '';

  var url = KP_SUPABASE_URL + '/functions/v1/public-collection-products?collection_id=' + encodeURIComponent(KP_COLLECTION_ID);

  fetch(url, { headers: { Authorization: 'Bearer ' + KP_ANON_KEY, apikey: KP_ANON_KEY } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var all = (data && data.products) || [];
      var target = variantName.toUpperCase().trim();
      var products = [];
      all.forEach(function (p) {
        // Safety net: even though this product list comes from the Kids
        // Party collection, collection membership is manually maintained
        // in Shopify and can be miscategorized (e.g. a Splatter Party
        // product accidentally added here too). Skip anything that isn't
        // actually titled as a Kids Party product.
        if ((p.title || '').toUpperCase().indexOf('KIDS PARTY') === -1) return;
        (p.variants || []).forEach(function (v) {
          if ((v.title || '').toUpperCase().trim() === target && v.available) {
            products.push({ title: p.title, variantId: v.id, price: Math.round(parseFloat(v.price) * 100) });
          }
        });
      });
      document.getElementById('kp-loading').style.display = 'none';
      kpState.dateMap = {};
      products.forEach(function (p) {
        var d = kpParseDate(p.title);
        if (!d) return;
        var k = kpKey(d);
        if (!kpState.dateMap[k]) kpState.dateMap[k] = [];
        kpState.dateMap[k].push(p);
      });
      var now = new Date();
      kpState.calYear = now.getFullYear();
      kpState.calMonth = now.getMonth();
      kpRenderCal();
    })
    .catch(function (e) {
      console.error('KP fetch error', e);
      document.getElementById('kp-loading').style.display = 'none';
    });
}

// ============================================================
//  CALENDAR
// ============================================================
function kpRenderCal() {
  var el = document.getElementById('kp-calendar');
  if (!el) return;
  var now = new Date(); now.setHours(0, 0, 0, 0);
  var mNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var year = kpState.calYear, month = kpState.calMonth;
  var firstDay = new Date(year, month, 1).getDay();
  var daysInMonth = new Date(year, month + 1, 0).getDate();
  var isNow = year === now.getFullYear() && month === now.getMonth();

  var h = '<div class="kp-month-header">';
  h += '<button class="kp-cal-arrow" onclick="kpCalPrev()" ' + (isNow ? 'disabled' : '') + '>\u2190</button>';
  h += '<span>' + mNames[month] + ' ' + year + '</span>';
  h += '<button class="kp-cal-arrow" onclick="kpCalNext()">\u2192</button>';
  h += '</div><div class="kp-cal-grid">';
  ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d) { h += '<div class="kp-day-label">' + d + '</div>'; });
  for (var e = 0; e < firstDay; e++) h += '<div class="kp-day kp-empty"></div>';
  for (var d = 1; d <= daysInMonth; d++) {
    var dt = new Date(year, month, d); dt.setHours(0, 0, 0, 0);
    var k = kpKey(dt);
    var isPast = dt < now;
    var has = !isPast && !!kpState.dateMap[k];
    var cls = 'kp-day' + (isPast ? ' kp-past' : (has ? ' kp-available' : ' kp-unavailable'));
    h += '<div class="' + cls + '" data-date="' + k + '"><span class="kp-day-num">' + d + '</span>';
    if (has) h += '<span class="kp-dot"></span>';
    h += '</div>';
  }
  h += '</div>';
  el.innerHTML = h;

  el.querySelectorAll('.kp-day.kp-available').forEach(function (day) {
    day.addEventListener('click', function () {
      var k = this.getAttribute('data-date');
      kpState.dateKey = k;
      var dt = new Date(k + 'T12:00:00');
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      kpState.dateLabel = days[dt.getDay()] + ', ' + months[dt.getMonth()] + ' ' + dt.getDate();
      kpBuildSlots(kpState.dateMap[k] || []);
      kpNext();
    });
  });
}

function kpCalPrev() {
  var now = new Date();
  if (kpState.calYear === now.getFullYear() && kpState.calMonth === now.getMonth()) return;
  kpState.calMonth--; if (kpState.calMonth < 0) { kpState.calMonth = 11; kpState.calYear--; }
  kpRenderCal();
}

function kpCalNext() {
  kpState.calMonth++; if (kpState.calMonth > 11) { kpState.calMonth = 0; kpState.calYear++; }
  kpRenderCal();
}

// ============================================================
//  STEP 4: Time slots
// ============================================================
function kpBuildSlots(products) {
  var lbl = document.getElementById('kp-selected-date-label');
  if (lbl) lbl.textContent = kpState.dateLabel;
  var container = document.getElementById('kp-slots');
  if (!container) return;
  products.sort(function (a, b) { return kpTime(a.title) - kpTime(b.title); });
  container.innerHTML = '';
  products.forEach(function (p) {
    var timeLabel = kpTimeLabel(p.title);
    var btn = document.createElement('button');
    btn.className = 'kp-slot-btn';
    btn.innerHTML = '<span class="kp-slot-time">' + timeLabel + '</span><span class="kp-slot-price">' + kpFmt(p.price) + '</span>';
    btn.addEventListener('click', function () {
      container.querySelectorAll('.kp-slot-btn').forEach(function (b) { b.classList.remove('kp-selected'); });
      btn.classList.add('kp-selected');
      kpState.variantId = p.variantId;
      kpState.variantPrice = p.price;
      kpState.timeLabel = timeLabel;
      kpState.is11am = /^11(:00)?am$/i.test(timeLabel.replace('*', ''));
      kpToggleParentStayField();
      kpUpdatePriceBar();
      kpNext();
    });
    container.appendChild(btn);
  });
}

// ============================================================
//  STEP 5: Party details (project + art time + party time after +
//  participants + conditional parent-stay + observer acknowledgment)
// ============================================================
function kpBuildProjectOptions() {
  var sel = document.getElementById('kp-project-select');
  if (!sel) return;
  KP_PROJECT_OPTIONS.forEach(function (o) {
    var opt = document.createElement('option');
    opt.value = o.value; opt.textContent = o.label;
    sel.appendChild(opt);
  });
}

var kpLastSpecificProjectKey = null;
var KP_90MIN_TAG = /\s*\(90\s*min(?:utes)?\)\s*$/i;

// Parses a raw metafield option string like "Fairy Doors (90min)" into
// { label: "Fairy Doors", requires90: true }. The "(90min)" tag is stripped
// from what's actually shown/stored — it's just a filtering hint.
function kpParseProjectOption(raw) {
  var requires90 = KP_90MIN_TAG.test(raw);
  var label = raw.replace(KP_90MIN_TAG, '').trim();
  return { label: label, requires90: requires90 };
}

function kpToggleSpecificProjectField() {
  var field = document.getElementById('kp-specific-project-field');
  var select = document.getElementById('kp-specific-project-select');
  var hint = document.getElementById('kp-specific-project-hint');
  if (!field || !select) return;

  var needsSub = KP_CATEGORIES_WITH_SUBPROJECT.indexOf(kpState.project) !== -1;
  if (!needsSub) {
    field.style.display = 'none';
    kpState.specificProject = '';
    kpState.specificProjectRaw = '';
    kpState.specificProjectLabel = '';
    kpState.customProjectText = '';
    select.innerHTML = '<option value="">\u2014 please select \u2014</option>';
    kpToggleCustomProjectField(false);
    kpLastSpecificProjectKey = null;
    return;
  }

  var is90 = kpState.artTime === 'yes - 90 minutes of art time';
  var key = kpState.project + '|' + (is90 ? '90' : '60');

  // Rebuild only when the category or the 60/90 art-time bucket actually
  // changes — not on every unrelated field change (participants, etc.) —
  // so we don't silently wipe an already-chosen selection.
  if (key === kpLastSpecificProjectKey) {
    field.style.display = select.options.length > 1 ? 'block' : 'none';
    return;
  }
  kpLastSpecificProjectKey = key;

  var categoryLabel = KP_PROJECT_LABELS[kpState.project];
  var rawOptions = (window.__KP_SPECIFIC_PROJECTS__ && window.__KP_SPECIFIC_PROJECTS__[categoryLabel]) || [];
  var parsed = rawOptions.map(kpParseProjectOption);

  // 90 minutes unlocks everything (60-min projects + 90-min-only projects).
  // 60 minutes only shows projects that don't require the longer slot.
  var visible = is90 ? parsed : parsed.filter(function (p) { return !p.requires90; });
  var hasHiddenNinety = !is90 && parsed.some(function (p) { return p.requires90; });

  // Alphabetize the metafield-driven options, then pin "Custom" and
  // "To be decided" at the bottom, in that order, on every list.
  visible.sort(function (a, b) { return a.label.localeCompare(b.label); });
  visible = visible.concat([
    { label: 'Custom', displayLabel: 'Custom (+$40)', requires90: false },
    { label: 'To be decided', requires90: false }
  ]);

  // Compare against the raw dropdown selection (not the combined
  // "Custom: ..." value) so a Custom write-in survives toggling art time
  // between 60 and 90 minutes instead of being wiped on every rebuild.
  var previousRaw = kpState.specificProjectRaw;
  var stillValid = previousRaw && visible.some(function (p) { return p.label === previousRaw; });

  select.innerHTML = '<option value="">\u2014 please select \u2014</option>';
  visible.forEach(function (p) {
    var o = document.createElement('option');
    o.value = p.label; o.textContent = p.displayLabel || p.label;
    select.appendChild(o);
  });

  field.style.display = visible.length ? 'block' : 'none';

  if (stillValid) {
    select.value = previousRaw;
    kpToggleCustomProjectField(previousRaw === 'Custom');
  } else {
    kpState.specificProject = '';
    kpState.specificProjectRaw = '';
    kpState.specificProjectLabel = '';
    kpState.customProjectText = '';
    select.value = '';
    kpToggleCustomProjectField(false);
  }

  if (hint) {
    hint.style.display = hasHiddenNinety ? 'block' : 'none';
  }
}

// Shows/hides the "Custom" write-in text field. Does NOT touch its value —
// callers that need to clear the text do so explicitly via kpState.customProjectText.
function kpToggleCustomProjectField(show) {
  var customField = document.getElementById('kp-custom-project-field');
  var customInput = document.getElementById('kp-custom-project-text');
  if (!customField) return;
  customField.style.display = show ? 'block' : 'none';
  if (!show && customInput) customInput.value = '';
}

// Recomputes the final kpState.specificProject value from the raw dropdown
// selection plus (if "Custom" is selected) the write-in text. This is the
// single source of truth used everywhere downstream (validation, review, cart).
function kpRecomputeSpecificProject() {
  if (kpState.specificProjectRaw === 'Custom') {
    var t = (kpState.customProjectText || '').trim();
    kpState.specificProject = t ? ('Custom: ' + t) : '';
  } else {
    kpState.specificProject = kpState.specificProjectRaw;
  }
  kpState.specificProjectLabel = kpState.specificProject;
}

function kpToggleParentStayField() {
  var field = document.getElementById('kp-parent-stay-field');
  if (!field) return;
  field.style.display = kpState.is11am ? 'block' : 'none';
  if (!kpState.is11am) {
    kpState.parentStay = 'no';
    var noRadio = document.getElementById('kp-parent-stay-no');
    if (noRadio) noRadio.checked = true;
  }
}

// ============================================================
//  OPTIONAL "Party Notes" question. Injected by JS so no Liquid
//  change is needed. It copies the CSS classes of the existing
//  "reason" field so it matches the widget styling automatically.
//  Sent to the cart as the "Party Notes" property; the dashboard
//  pre-fills Special Notes from it (plus the Shopify order note).
// ============================================================
function kpBuildNotesField() {
  if (document.getElementById('kp-party-notes-text')) return;
  var reasonInput = document.getElementById('kp-reason-text');
  var reasonField = reasonInput ? reasonInput.parentNode : null;
  var anchor = document.getElementById('kp-details-subtotal') || document.getElementById('kp-details-error');
  if (!anchor || !anchor.parentNode) return;

  var wrap = document.createElement('div');
  wrap.id = 'kp-party-notes-field';
  // Only borrow the wrapper's classes if it's a field wrapper, not the step container itself
  if (reasonField && reasonField.className && reasonField.id !== 'kp-step-details' && !/kp-step/.test(reasonField.className)) wrap.className = reasonField.className;
  wrap.style.marginBottom = '16px';

  var label = document.createElement('label');
  label.setAttribute('for', 'kp-party-notes-text');
  var reasonLabel = reasonField ? reasonField.querySelector('label') : null;
  if (reasonLabel && reasonLabel.className) label.className = reasonLabel.className;
  label.style.display = 'block';
  label.appendChild(document.createTextNode('Anything else you\u2019d like to share to help us make this party extra special? '));
  var opt = document.createElement('span');
  opt.style.fontWeight = 'normal';
  opt.style.opacity = '0.7';
  opt.textContent = '(optional)';
  label.appendChild(opt);

  var ta = document.createElement('textarea');
  ta.id = 'kp-party-notes-text';
  ta.rows = 3;
  ta.maxLength = 1000;
  ta.placeholder = 'Favourite colours, a special theme, anything we should know\u2026';
  if (reasonInput && reasonInput.className) ta.className = reasonInput.className;
  ta.style.width = '100%';
  ta.style.boxSizing = 'border-box';
  ta.style.resize = 'vertical';
  ta.style.fontFamily = 'inherit';
  ta.addEventListener('input', function () { kpState.partyNotes = ta.value; });

  wrap.appendChild(label);
  wrap.appendChild(ta);
  anchor.parentNode.insertBefore(wrap, anchor);
}

function kpEscHtml(str) {
  return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\n/g, '<br>');
}

// Shows the selected studio with a "Change studio" link that jumps
// back to the studio list (step 2).
function kpSetStudioLabel(name) {
  var labelEl = document.getElementById('kp-studio-label');
  if (!labelEl) return;
  labelEl.textContent = '\uD83D\uDCCD ' + name + ' ';
  var link = document.createElement('a');
  link.href = '#';
  link.textContent = 'Change studio';
  link.style.fontSize = '0.8em';
  link.style.fontWeight = 'normal';
  link.style.color = '#666';
  link.style.textDecoration = 'underline';
  link.style.marginLeft = '8px';
  link.addEventListener('click', function (e) {
    e.preventDefault();
    kpGoTo(1);
  });
  labelEl.appendChild(link);
  labelEl.style.display = 'block';
}

function kpBindDetailFields() {
  var projectSel = document.getElementById('kp-project-select');
  var artTimeSel = document.getElementById('kp-art-time');
  var partyAfterSel = document.getElementById('kp-time-after');
  var participSel = document.getElementById('kp-participants');

  [projectSel, artTimeSel, partyAfterSel, participSel].forEach(function (el) {
    if (el) el.addEventListener('change', kpUpdateDetailsUI);
  });

  document.querySelectorAll('input[name="kp-parent-stay"]').forEach(function (r) {
    r.addEventListener('change', function () {
      kpState.parentStay = this.value;
      kpUpdateDetailsUI();
    });
  });

  var specificSel = document.getElementById('kp-specific-project-select');
  if (specificSel) specificSel.addEventListener('change', function () {
    kpState.specificProjectRaw = specificSel.value;
    kpToggleCustomProjectField(specificSel.value === 'Custom');
    kpRecomputeSpecificProject();
    kpUpdateDetailsSubtotal();
    kpUpdatePriceBar();
    var err = document.getElementById('kp-details-error');
    if (err) err.style.display = 'none';
  });

  var customInput = document.getElementById('kp-custom-project-text');
  if (customInput) customInput.addEventListener('input', function () {
    kpState.customProjectText = customInput.value;
    kpRecomputeSpecificProject();
    kpUpdateDetailsSubtotal();
    kpUpdatePriceBar();
    var err = document.getElementById('kp-details-error');
    if (err) err.style.display = 'none';
  });

  var ackBox = document.getElementById('kp-observer-acknowledge');
  if (ackBox) ackBox.addEventListener('change', function () {
    var err = document.getElementById('kp-details-error');
    if (err) err.style.display = 'none';
  });

  var reasonInput = document.getElementById('kp-reason-text');
  if (reasonInput) reasonInput.addEventListener('input', function () {
    kpState.reason = reasonInput.value;
    var err = document.getElementById('kp-details-error');
    if (err) err.style.display = 'none';
  });
}

function kpExtrasKey() {
  return kpState.artTime + '|' + kpState.partyAfter + '|' + kpState.participants;
}

function kpUpdateDetailsUI() {
  var projectSel = document.getElementById('kp-project-select');
  var artTimeSel = document.getElementById('kp-art-time');
  var partyAfterSel = document.getElementById('kp-time-after');
  var participSel = document.getElementById('kp-participants');

  kpState.project = projectSel.value;
  kpState.artTime = artTimeSel.value;
  kpState.artTimeLabel = artTimeSel.options[artTimeSel.selectedIndex].textContent;
  kpState.partyAfter = partyAfterSel.value;
  kpState.partyAfterLabel = partyAfterSel.options[partyAfterSel.selectedIndex].textContent;
  kpState.participants = participSel.value;
  kpState.participantsLabel = participSel.options[participSel.selectedIndex].textContent;

  var needsUpgrade = KP_UPGRADE_PROJECTS.indexOf(kpState.project) !== -1;
  var upgradeNotice = document.getElementById('kp-upgrade-notice');
  if (upgradeNotice) upgradeNotice.style.display = needsUpgrade ? 'block' : 'none';

  kpToggleSpecificProjectField();
  kpUpdateDetailsSubtotal();
  kpUpdatePriceBar();
}

function kpDetailsSubtotalParts() {
  var needsUpgrade = KP_UPGRADE_PROJECTS.indexOf(kpState.project) !== -1;
  var key = kpExtrasKey();
  var extrasCentsRaw = KP_EXTRAS_PRICES.hasOwnProperty(key) ? KP_EXTRAS_PRICES[key] : 0;
  var extrasCents = (kpIsMember && kpMemberDiscountConfig.extras_discount_pct)
    ? Math.round(extrasCentsRaw * (1 - kpMemberDiscountConfig.extras_discount_pct))
    : extrasCentsRaw;

  var parentYes = kpState.is11am && kpState.parentStay === 'yes';
  var count = kpParticipantCount(kpState.participants);
  var parentCents = parentYes ? kpParentStayPriceCents * (count - 1) : 0; // no member discount on this add-on

  var baseRaw = kpState.variantPrice || 0;
  var base = (kpIsMember && kpMemberDiscountConfig.base_discount_flat_cents)
    ? Math.max(0, baseRaw - kpMemberDiscountConfig.base_discount_flat_cents)
    : baseRaw;

  var upgradeCents = needsUpgrade ? 4000 : 0; // no member discount on the project upgrade fee

  var isCustom = kpState.specificProjectRaw === 'Custom';
  var customCents = isCustom ? 4000 : 0; // no member discount on the custom write-in fee

  return {
    base: base,
    baseRaw: baseRaw,
    isMember: kpIsMember,
    memberSavings: (baseRaw - base) + (extrasCentsRaw - extrasCents),
    needsUpgrade: needsUpgrade,
    upgradeCents: upgradeCents,
    extrasCents: extrasCents,
    isCustom: isCustom,
    customCents: customCents,
    parentYes: parentYes,
    parentCents: parentCents,
    count: count,
    total: base + upgradeCents + extrasCents + customCents + parentCents
  };
}

function kpUpdateDetailsSubtotal() {
  var box = document.getElementById('kp-details-subtotal');
  if (!box) return;
  var parts = kpDetailsSubtotalParts();
  if (!kpState.project) { box.style.display = 'none'; return; }
  box.style.display = 'block';

  document.getElementById('kp-subtotal-base').textContent = kpFmt(parts.baseRaw);

  var upgradeRow = document.getElementById('kp-subtotal-upgrade-row');
  if (upgradeRow) upgradeRow.style.display = parts.needsUpgrade ? 'flex' : 'none';

  var customRow = document.getElementById('kp-subtotal-custom-row');
  if (customRow) customRow.style.display = parts.isCustom ? 'flex' : 'none';

  var extrasRow = document.getElementById('kp-subtotal-extras-row');
  var extrasEl = document.getElementById('kp-subtotal-extras');
  if (extrasRow) extrasRow.style.display = parts.extrasCents > 0 ? 'flex' : 'none';
  if (extrasEl) extrasEl.textContent = kpFmt(parts.extrasCents);

  var parentRow = document.getElementById('kp-subtotal-parent-row');
  var parentEl = document.getElementById('kp-subtotal-parent');
  if (parentRow) parentRow.style.display = parts.parentYes ? 'flex' : 'none';
  if (parentEl) parentEl.textContent = kpFmt(parts.parentCents) + ' (' + (parts.count - 1) + ' \u00d7 ' + kpFmt(kpParentStayPriceCents) + ')';

  var memberRow = document.getElementById('kp-subtotal-member-row');
  if (memberRow) memberRow.style.display = (parts.isMember && parts.memberSavings > 0) ? 'flex' : 'none';
  var memberEl = document.getElementById('kp-subtotal-member-savings');
  if (memberEl) memberEl.textContent = '\u2212' + kpFmt(parts.memberSavings);

  document.getElementById('kp-subtotal-total').textContent = kpFmt(parts.total);
}

function kpDetailsNext() {
  var errEl = document.getElementById('kp-details-error');
  errEl.style.display = 'none';

  if (!kpState.reason || !kpState.reason.trim()) {
    errEl.textContent = 'Please tell us what you\u2019re celebrating before continuing.';
    errEl.style.display = 'block';
    return;
  }

  if (!kpState.project) {
    errEl.textContent = 'Please select a project type before continuing.';
    errEl.style.display = 'block';
    return;
  }

  var needsSub = KP_CATEGORIES_WITH_SUBPROJECT.indexOf(kpState.project) !== -1;
  if (needsSub && !kpState.specificProjectRaw) {
    errEl.textContent = 'Please select which specific project you\u2019d like before continuing.';
    errEl.style.display = 'block';
    return;
  }
  if (needsSub && kpState.specificProjectRaw === 'Custom' && !kpState.specificProject) {
    errEl.textContent = 'Please describe your custom project idea before continuing.';
    errEl.style.display = 'block';
    return;
  }

  var ackBox = document.getElementById('kp-observer-acknowledge');
  if (ackBox && !ackBox.checked) {
    errEl.textContent = 'Please confirm you have read and understood the adult observer policy before continuing.';
    errEl.style.display = 'block';
    return;
  }

  kpShowReview();
  kpNext();
}

// ============================================================
//  STEP 6: Review + Book
// ============================================================
function kpShowReview() {
  var parts = kpDetailsSubtotalParts();
  var rows = [
    { label: 'Studio', value: kpState.studioName },
    { label: 'Date', value: kpState.dateLabel },
    { label: 'Time', value: kpState.timeLabel },
    { label: 'Occasion', value: kpState.reason },
    { label: 'Project', value: KP_PROJECT_LABELS[kpState.project] || kpState.project }
  ];
  if (kpState.specificProject) {
    rows.push({ label: 'Specific Project', value: kpState.specificProject });
  }
  rows.push({ label: 'Art time', value: kpState.artTimeLabel });
  rows.push({ label: 'Party time after', value: kpState.partyAfterLabel });
  rows.push({ label: 'Participants', value: kpState.participantsLabel });
  if (parts.parentYes) {
    rows.push({ label: 'Parent observers', value: 'Yes (' + (parts.count - 1) + ' extra adults)' });
  }
  if (kpState.partyNotes && kpState.partyNotes.trim()) rows.push({ label: 'Notes', value: kpEscHtml(kpState.partyNotes.trim()) });
  var html = rows.map(function (r) {
    return '<div class="kp-review-row"><span class="kp-review-label">' + r.label + '</span><span class="kp-review-value">' + r.value + '</span></div>';
  }).join('');
  document.getElementById('kp-review-summary').innerHTML = html;

  document.getElementById('kp-review-subtotal-base').textContent = kpFmt(parts.baseRaw);
  var upgradeRow = document.getElementById('kp-review-upgrade-row');
  if (upgradeRow) upgradeRow.style.display = parts.needsUpgrade ? 'flex' : 'none';
  var customRow = document.getElementById('kp-review-custom-row');
  if (customRow) customRow.style.display = parts.isCustom ? 'flex' : 'none';
  var extrasRow = document.getElementById('kp-review-extras-row');
  var extrasEl = document.getElementById('kp-review-extras');
  if (extrasRow) extrasRow.style.display = parts.extrasCents > 0 ? 'flex' : 'none';
  if (extrasEl) extrasEl.textContent = kpFmt(parts.extrasCents);
  var parentRow = document.getElementById('kp-review-parent-row');
  var parentEl = document.getElementById('kp-review-parent');
  if (parentRow) parentRow.style.display = parts.parentYes ? 'flex' : 'none';
  if (parentEl) parentEl.textContent = kpFmt(parts.parentCents);
  var memberRow = document.getElementById('kp-review-member-row');
  if (memberRow) memberRow.style.display = (parts.isMember && parts.memberSavings > 0) ? 'flex' : 'none';
  var memberEl = document.getElementById('kp-review-member-savings');
  if (memberEl) memberEl.textContent = '\u2212' + kpFmt(parts.memberSavings);
  document.getElementById('kp-review-total').textContent = kpFmt(parts.total);
}

function kpUpdatePriceBar() {
  var bar = document.getElementById('kp-price-bar');
  var amountEl = document.getElementById('kp-price-bar-total');
  var breakdownEl = document.getElementById('kp-price-bar-breakdown');
  if (!bar || !amountEl) return;
  var base = kpState.variantPrice;
  if (!base) { bar.style.display = 'none'; return; }
  var parts = kpDetailsSubtotalParts();
  amountEl.textContent = kpFmt(parts.total);
  if (breakdownEl) {
    var extra = parts.total - parts.base;
    var text = extra > 0 ? (kpFmt(parts.base) + ' base + ' + kpFmt(extra) + ' extras') : (kpFmt(parts.base) + ' base price');
    if (parts.isMember && parts.memberSavings > 0) text += ' \u00b7 member savings applied';
    breakdownEl.textContent = text;
  }
  bar.style.display = 'block';
}

function kpFmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

// ============================================================
//  ADD TO CART
// ============================================================
function kpAddToCart() {
  var errEl = document.getElementById('kp-error');
  errEl.style.display = 'none';

  if (!kpState.variantId) {
    errEl.textContent = 'Please select a date and time first.'; errEl.style.display = 'block'; return;
  }

  var btn = document.getElementById('kp-add-to-cart');
  btn.disabled = true; btn.textContent = 'Adding\u2026';

  var linkedTo = String(kpState.variantId);
  var items = [];

  // 1. Main party booking
  var mainProps = { 'Reason for Celebration': kpState.reason, 'Project Type': KP_PROJECT_LABELS[kpState.project] || kpState.project };
  if (kpState.specificProject) mainProps['Specific Project'] = kpState.specificProject;
  if (kpState.partyNotes && kpState.partyNotes.trim()) mainProps['Party Notes'] = kpState.partyNotes.trim();
  items.push({
    id: parseInt(kpState.variantId, 10),
    quantity: 1,
    properties: mainProps
  });

  // 2. Project upgrade
  if (KP_UPGRADE_PROJECTS.indexOf(kpState.project) !== -1) {
    items.push({ id: KP_UPGRADE_VARIANT_ID, quantity: 1, properties: { '_linked_to': linkedTo } });
  }

  // 3. Custom write-in project fee (stacks with the upgrade fee above,
  // since it's a separate charge for a fully custom design)
  if (kpState.specificProjectRaw === 'Custom' && kpState.specificProject) {
    items.push({ id: KP_CUSTOM_VARIANT_ID, quantity: 1, properties: { '_linked_to': linkedTo } });
  }

  // 4. Extras (art time / party time after / participants)
  var key = kpExtrasKey();
  if (key !== KP_BASE_EXTRAS_KEY) {
    var extrasId = KP_EXTRAS_VARIANTS[key];
    if (extrasId) items.push({ id: extrasId, quantity: 1, properties: { '_linked_to': linkedTo } });
  }

  // 5. Parent stay add-on
  var finishAdd = function () {
    if (kpState.is11am && kpState.parentStay === 'yes' && kpParentStayVariantId) {
      var count = kpParticipantCount(kpState.participants);
      items.push({ id: kpParentStayVariantId, quantity: count - 1, properties: { '_linked_to': linkedTo } });
    }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.items || (data[0] && data[0].id)) { window.location.href = '/cart'; }
        else {
          btn.disabled = false; btn.textContent = 'Book Now';
          errEl.textContent = data.description || 'Something went wrong. Please try again.'; errEl.style.display = 'block';
        }
      })
      .catch(function () {
        btn.disabled = false; btn.textContent = 'Book Now';
        errEl.textContent = 'Something went wrong. Please try again.'; errEl.style.display = 'block';
      });
  };

  if (kpState.is11am && kpState.parentStay === 'yes' && !kpParentStayVariantId) {
    kpLoadParentStayVariant(finishAdd);
  } else {
    finishAdd();
  }
}

// ============================================================
//  UTILITY (shared date/time parsing — matches title convention
//  "6pm Fri Sep 11th | Kids Party")
// ============================================================
function kpParseDate(title) {
  var m = title.match(/(\w{3})\s+(\d{1,2})/);
  if (!m) return null;
  var months = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11 };
  var mo = months[m[1]], day = parseInt(m[2], 10);
  if (mo === undefined || isNaN(day)) return null;
  var now = new Date(), yr = now.getFullYear();
  var c = new Date(yr, mo, day);
  if (c < now) c = new Date(yr + 1, mo, day);
  return c;
}
function kpKey(d) { return d.getFullYear() + '-' + kpP(d.getMonth() + 1) + '-' + kpP(d.getDate()); }
function kpP(n) { return n < 10 ? '0' + n : '' + n; }
function kpTime(title) {
  var m = title.match(/^(\*?)(\d+):?(\d*)(am|pm)/i);
  if (!m) return 9999;
  var h = parseInt(m[2], 10), min = m[3] ? parseInt(m[3], 10) : 0, ap = m[4].toLowerCase();
  if (ap === 'pm' && h !== 12) h += 12;
  if (ap === 'am' && h === 12) h = 0;
  return h * 60 + min;
}
function kpTimeLabel(title) {
  var m = title.match(/^(\*?\d+(?::\d+)?(?:am|pm))/i);
  return m ? m[1].replace('*', '') : title.split('|')[0].trim();
}